import {ReactNode} from "react";
import { Button } from '../ui/button';
import { LoaderCircle } from 'lucide-react';

type Props = {
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    loading?: boolean
    disabled?: boolean
    label?: string | React.ReactNode
    className?: string
    variant?: ButtonVariant
    style?: React.CSSProperties
    icon?: ReactNode
    size?: 'sm' | 'default' | 'icon' | 'lg',
    title?: string
};

export type ButtonVariant = "link" | "default" | "secondary" | "destructive" | "outline" | "ghost" | "black" | null | undefined
const ButtonComponent = ({onClick, loading, disabled, label, className = "", variant, icon, style ={}, size = 'default', title}: Props) => {


    return (
        <Button size={size} title={title} variant={variant ?? "default"} style={style} className={`text-white ${className}`} disabled={disabled} onClick={(event) => {
            if (onClick) {
                onClick(event)
            }
        }}>

            {icon ? !loading ? icon : null : null}
            {loading && <LoaderCircle className="animate-spin mr-2"/>}
            {label}
        </Button>
    );
};

export default ButtonComponent